module.exports = __webpack_public_path__ + "static/media/img1.9144963d.jpg";